import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const SuggestedDosagesHero: React.FC = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="mb-4 p-4 bg-gray-50 border border-gray-200 rounded-md shadow-sm">
      <p className="text-gray-800">
        Suggested dosages provided here are for sample, example, research, and educational purposes only. They are not intended to diagnose, treat, cure, or prevent any disease. If you have insights or data to share, feel free to <Link to="/contribute" className="text-blue-600 font-medium hover:underline">contribute your own sources</Link>. Please consult with a qualified healthcare professional before starting any regimen.
      </p>

      {/* Conditionally Rendered Detailed Content */}
      {showMore && (
        <div className="mt-2 text-gray-800">
          <p>
            Suggested dosages can include peptides, supplements, food, drinks, medications, or activities. Customize details like dosage (e.g., <code>10 mg</code>), timing (e.g., <em>AM</em> or <em>before bed</em>), and frequency. For example:
          </p>
          <ul className="mt-2 ml-6 list-disc">
            <li>
              <strong>Frequency:</strong> <code>1 day</code> means every day, <code>2 days</code> means every other day, and <code>3 days</code> means every three days.
            </li>
            <li>
              <strong>Timing:</strong> Choose from <em>AM</em>, <em>PM</em>, <em>midday</em>, <em>before bed</em>, or even <em>before exercise</em>.
            </li>
            <li>
              <strong>Cycles:</strong> Add optional "on" and "off" days (e.g., <code>5 days on</code>, <code>2 days off</code>) for more complex schedules.
            </li>
            <li>
              <strong>Duration:</strong> Specify how long the regimen lasts (e.g., <code>8 weeks</code>), with optional repeat or cooldown periods (e.g., <code>2 weeks off</code>).
            </li>
          </ul>
        </div>
      )}

      {/* Toggle Button */}
      <button
        onClick={() => setShowMore(!showMore)}
        className="mt-2 text-blue-600 font-medium hover:underline"
      >
        {showMore ? 'Show Less' : 'Show More'}
      </button>
    </div>
  );
};
